<script>
    import {getTimestamp, formatTimestamp} from '../Utilities/time_format';
    import {session} from '../Utilities/Session.svelte';
    import FormModal from '../Forms/FormModal.svelte';
    import {confirm} from './Confirmation.svelte';
    import NoteTags from './NoteTags.svelte'
    import PreviousNotes from './PreviousNotes.svelte';

    import {userMap} from '../Utilities/Session.svelte';

    import {clean} from '../Utilities/Cleaner.svelte';
    import markdown from '../Utilities/markdown';

    export let control;
    export let assessment;

    export let cache = {};

    export let searchText;

    import Fa from 'svelte-fa';
    import {faPencil} from "@fortawesome/free-solid-svg-icons";

    let tags = [];
    let showFormModal;

    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    function highlight(searchText, text) {
        if (searchText) {
            let re = new RegExp(`(${escapeRegExp(searchText)})`, "ig");
            return text.replace(re, `#$1#`);
        } else {
            return text;
        }
    }

    function editNote(note) {

        let fields = [
            {
                name: "tags",
                type: "custom",
                component: NoteTags,
                componentProps: {
                    comment_tags: [...assessment.assessment_type_data.comment_tags, ...assessment.comment_tags.tags]
                }
            },{
                name: "note",
                label: "Note",
                type: "textarea",
                required: true,
            }
        ]

        if ($session.user.email != note.user) {
            console.log($session.user.email, note.user);
            fields[1].fieldProps = {
                readonly: true
            }
        }

        showFormModal = {
            fields,
            title: "Edit Note",
            data: note,
            showDelete: true,
            cancelAction: () => showFormModal = undefined,
            saveAction: (note) => {
                assessment.model.updateNote(note);
                showFormModal = undefined
            },
            deleteAction: () => {
                confirm("Are you sure you want to delete this note?").then(() => {
                    assessment.model.deleteNote(note);
                    showFormModal = undefined
                }).catch(err => {});
            }
        }
    }

    function submitNote(evt) {
        let note_text = evt.target.note.value;

        if (!note_text) return;

        let note_tags = tags;

        assessment.model.addNote(control.id, note_text, note_tags);
        cache[control.id] = "";

        //reset form
        tags = [];
        evt.target.reset();
        evt.target.note.focus();
    }

    function handleEnter(evt) {
        if (evt.keyCode == 13) {
            if (evt.altKey) {
                evt.target.value += "\r\n";
            } else {
                submitNote({
                    target: evt.target.form
                });
                evt.preventDefault();
                return false;
            }
        }
    }
</script>

{#if assessment.previous_control_notes.notes && assessment.previous_control_notes.notes[control.id]}
    <PreviousNotes notes={assessment.previous_control_notes.notes[control.id]} />
{/if}

 <h3 class="title is-5">Notes</h3>
{#if assessment.control_notes[control.id]}
    {#each assessment.control_notes[control.id] as note (note._id)}
        <article class="media">
            <div class="media-content">
                <div class="content">
                    <p class="comment is-size-6">
                        <strong>{$userMap[note.user] || note.user}</strong>
                        <small>
                            {#if note.ts}
                                {formatTimestamp(note.ts)}
                            {:else}
                                {note.timestamp}
                            {/if}
                            <span class="icon pointer" on:click={() => editNote(note)}>
                                <i><Fa icon={faPencil} /></i>
                            </span>
                        </small>
                        <span class="tags">
                            {#each note.tags || [] as tag}
                                <span class="tag is-{tag.color_class}">{tag.name}</span>
                            {/each}
                        </span>
                        <span class="note">{@html clean(markdown(highlight(searchText, note.note)))}</span>
                    </p>
                </div>
            </div>
        </article>
    {/each}
    <hr>
{/if}

<form on:submit|preventDefault={submitNote}>
    <input name="control_id" type="hidden" value="{control.id}">
    <NoteTags bind:value={tags} comment_tags={[...(assessment.assessment_type_data.comment_tags || []), ...assessment.comment_tags.tags]}></NoteTags>
    <div class="field">
        <div class="control">
            <textarea class="textarea" name="note" on:keydown={handleEnter} bind:value={cache[control.id]}></textarea>
            <span class="is-pulled-left is-size-6 markdown-help">
                *<strong>bold</strong>* _<em>italics</em>_ ~<s>strikethrough</s>~ #<mark>highlight</mark>#
            </span>
        </div>
    </div>

    <div class="buttons is-right">
        <button class="button is-right">Save</button>
    </div>
</form>

{#if showFormModal}
    <FormModal {...showFormModal}></FormModal>
{/if}

<style>
    .tag.pointer {
        user-select: none;
    }
    .note {
        margin-top: .25rem;
    }

    .tags {
        margin-bottom: 0;
    }
</style>